var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCross(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.522.478a1.63 1.63 0 010 2.306L2.784 14.522a1.63 1.63 0 01-2.306-2.306L12.216.478a1.63 1.63 0 012.306 0z",
    fill: "#000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M.477.477a1.63 1.63 0 012.305 0l11.74 11.742a1.63 1.63 0 11-2.304 2.304L.478 2.78a1.63 1.63 0 010-2.304z",
    fill: "#000"
  })));
}

export default SvgCross;